import { render } from "./Sidebar.vue?vue&type=template&id=5c67043b&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=5c67043b&lang=scss&scoped=true"
import "./Sidebar.vue?vue&type=style&index=1&id=5c67043b&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c67043b"]])

export default __exports__